import { linkDefaults } from "@/modules/billing/paymentMethodDefaults.tsx";
import type { LinkMethod } from "@/modules/billing/paymentMethods.ts";
import PaypalCheckoutPaymentForm, {
    type PaypalCheckoutProcessorConfig,
} from "@/modules/billing/paypal/PaypalCheckoutPaymentForm.tsx";

export function makePaypalCheckout(config: PaypalCheckoutProcessorConfig) {
    return config.methods.map((method): LinkMethod => {
        const base = linkDefaults(config, method);
        return {
            ...base,
            PaymentForm: (props) => <PaypalCheckoutPaymentForm {...props} method={method} config={config} />,
        };
    });
}
